import { Center, VStack } from '@hover/blueprint';
import React from 'react';

import {
  PROJECT_CARD_HEIGHT,
  PROJECT_CARD_WIDTH,
} from 'src/modules/homeownerApp/components/Projects/Menu/ProjectSelection/ProjectSelectionCard';
import { Skeleton } from 'src/shared/components/Skeleton/Skeleton';

const ProjectSelectionCardSkeleton = () => (
  <VStack alignItems={{ base: 'center', tablet: 'flex-start' }}>
    <Center marginBottom={200} position="relative">
      <Skeleton
        borderRadius={300}
        height={PROJECT_CARD_HEIGHT}
        transition="filter 0.2s ease-in-out"
        width={PROJECT_CARD_WIDTH}
      />
    </Center>
  </VStack>
);

export { ProjectSelectionCardSkeleton };
